/*
 * General utils for managing cookies in Typescript.
 */
export var setCookie = function (name, val) {
    var date = new Date();
    var value = val;
    // Set it expire in 1 year
    date.setTime(date.getTime() + (365 * 24 * 60 * 60 * 1000));
    // Set it
    document.cookie = name + "=" + value + "; expires=" + date.toUTCString() + "; path=/; secure";
};
export var getCookie = function (name) {
    var value = "; " + document.cookie;
    var parts = value.split("; " + name + "=");
    if (parts.length === 2) {
        var poppedPart = parts.pop();
        if (poppedPart) {
            return poppedPart.split(";").shift();
        }
    }
    return undefined;
};
export var deleteCookie = function (name) {
    var date = new Date();
    // Set it expire in -1 days
    date.setTime(date.getTime() + (-1 * 24 * 60 * 60 * 1000));
    // Set it
    document.cookie = name + "=; expires=" + date.toUTCString() + "; path=/; secure";
};
